import React, { useState } from "react";
import { Link } from "react-router-dom"; // <-- Import Link for navigation
import icon1 from "assets/images/CareerPage/calendar.png";
import icon2 from "assets/images/CareerPage/location.png";
import icon3 from "assets/images/CareerPage/share.png";
import icon4 from "assets/images/CareerPage/email.png";
import icon5 from "assets/images/CareerPage/phone.png";
import "./CareerContent.css";
// import { useNavigate } from "react-router-dom";


const CareerContent = () => {
  const [copyMessage, setCopyMessage] = useState("");
  // const navigate = useNavigate();
  const handleCopyLink = () => {
    const link = window.location.href;
    navigator.clipboard.writeText(link).then(() => {
      setCopyMessage("Link copied to clipboard!");
      setTimeout(() => setCopyMessage(""), 2000);
    });
  };

  return (
    <div className="career-page">
      <div className="job-description">
      {/* <div className="cp1-back-button-container">
        <button className="cp1-back-button" onClick={() => navigate("/careers")}>
          <svg viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
          Back to Career Page
        </button>
      </div> */}
        <h2>We&apos;re Hiring: Software Developer</h2>
        <p>
        Are you a skilled Software Developer looking for an exciting opportunity? Join our dynamic team as we continue to expand and enhance our software solutions!
        </p>
        <p>
          <strong>Key Responsibilities:</strong>
          <ol>
            <li>Design, build, and maintain software applications.</li>
            <li>Write clean, scalable, and efficient code following best practices.</li>
            <li>Troubleshoot, debug, and upgrade existing software.</li>
            <li>Collaborate with cross-functional teams to define, design, and ship new features.</li>
          </ol>
        </p>
        <p>
          <strong>Requirements:</strong>
          <ol>
            <li>Bachelor&apos;s degree or above, major in Computer Science, or a related field.</li>
            <li>Strong proficiency in at least one programming language (e.g., Java, Python, JavaScript).</li>
            <li>Experience with version control systems (e.g., Git).</li>
            <li>Excellent problem-solving abilities and a keen eye for detail.</li>
          </ol>
        </p>
      </div>

      <div className="career-form-section">
        <div className="career-event-details">
          <p>
            <span className="career-icon">
              <img src={icon1} alt="Calendar Icon" />
            </span>
            <strong>Dec 21st 2024 - Dec 31st 2025</strong>
            <br />
            9:00 AM - 6:00 PM | GMT +08
          </p>
          <p>
            <span className="career-icon">
              <img src={icon4} alt="Email Icon" />
            </span>
            <strong>admin@squarecloud.asia</strong>
          </p>
          <p>
            <span className="career-icon">
              <img src={icon5} alt="Phone Icon" />
            </span>
            <strong>03-7497-2558</strong>
          </p>
          <p>
            <span className="career-icon">
              <img src={icon2} alt="Location Icon" />
            </span>
            <strong>SquareCloud Malaysia</strong>
            <br />
            D-61-3A Level 3A Jaya One, No. 72A Jalan Prof Diraja Ungku Aziz,
            46200 Petaling Jaya, Selangor, Malaysia
          </p>
          <p className="share-link" onClick={handleCopyLink}>
            <span className="career-icon">
              <img src={icon3} alt="Share Icon" />
            </span>
            <strong>Share this event</strong>
          </p>
          {copyMessage && <span className="copy-message">{copyMessage}</span>}

          {/* Link to /CPForm */}
          <Link to="/career-form" className="career-apply-button">
            Apply for Careers Here
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CareerContent;
